import builder from '../builder';
import SofaDouble from '../../streamline-icons/bold/sofa-double.svg';

export default builder('IconSofaDoubleBold', SofaDouble);
